const { isUndefined } = require('lodash');

class listGroupController {
    constructor(shopperService, announcerService) {
        this.shopperService = shopperService;
        this.expanded = isUndefined(this.expanded) ? true : this.expanded;
        this.announcerService = announcerService;
    }

    toggleGroup() {
        this.expanded = !this.expanded;
        this.announcerService.announce(`${this.groupName} has been ${this.groupToggleState ? 'expanded' : 'minimized'}`);
    }
}

listGroupController.$inject = ['ShopperService', 'AnnouncerService'];

const listGroupComponentDefinition = {
    bindings: {
        groupName: '@',
        toolTipText: '@?',
        expanded: '=?',
    },
    transclude: {
        cta: '?wowListGroupCta',
        content: 'wowListGroupContent',
    },
    controller: listGroupController,
    template: require('./list-group.component.html').trim(),
};

module.exports = {
    listGroupController,
    listGroupComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/lists/listgroup/list-group.component.js